import { useState, useEffect } from 'react'

import { truncateText } from '~/apps/consumer/helpers/TruncateText'
import Box from '~/core/Box'
import getColor from '~/lib/getColor'

interface ActivityLogNotePropTypes {
    note: string
}

const ActivityLogNote = (props: ActivityLogNotePropTypes) => {
    const { note } = props

    const [isCondensedMessage, setIsCondensedMessage] = useState(false)
    const condensedNote = truncateText(note, 150)

    useEffect(() => {
        if (note.length > 150) {
            setIsCondensedMessage(true)
        }
    }, [note.length, setIsCondensedMessage])

    return (
        <Box
            border={`1px solid ${getColor('blackAlpha15')}`}
            borderRadius="4px"
            marginTop="4px"
            padding="8px"
            direction="col"
        >
            "{isCondensedMessage ? condensedNote : note}"
            {isCondensedMessage ? (
                <span
                    style={{
                        marginTop: '8px',
                        fontSize: '11px',
                        cursor: 'pointer',
                    }}
                    onClick={() => setIsCondensedMessage(false)}
                >
                    Show more
                </span>
            ) : (
                <span
                    style={{
                        marginTop: '8px',
                        fontSize: '11px',
                        cursor: 'pointer',
                    }}
                    onClick={() => setIsCondensedMessage(true)}
                >
                    Show less
                </span>
            )}
        </Box>
    )
}

export default ActivityLogNote
